import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "simplifyWords",
})
export class SimplifyWordsPipe implements PipeTransform {
  transform(value: string): string {
    if (value === undefined || value == "") return value;
    const startIndex = value.indexOf("(");
    if (startIndex !== -1) {
      return value.substring(0, startIndex).trim();
    }
    return value;
  }
}
